
import './reviews.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import brand from '../../service/brand';
import zone from '../../service/zone';
import user from '../../service/user';
import review from '../../service/review';
import nps from '../../service/nps';
import rating from '../../service/rating';
import survey from '../../service/survey';

import menuLayout from '../../directive/menu-layout';
import dateFormat from '../../directive/date-format';
import starRating from '../../directive/star-rating';
import storeDateSelector from '../../directive/store-date-selector';

import routing from './reviews.routes';
import ReviewsController from './reviews.controller';

export default angular.module('page.reviews', [
		uirouter,

		brand,
		zone,
		user,
		review,
		nps,
		rating,
		survey,

		menuLayout,
		dateFormat,
		starRating,
		storeDateSelector,
		'ui.bootstrap.datetimepicker',
		'angularUtils.directives.dirPagination',
	])
	.config(routing)
	.controller('ReviewsController', ReviewsController)
	.name;



// WEBPACK FOOTER //
// ./src/page/reviews/index.js